import * as React from "react";

import DienteMo from "./DienteMo"
import DientePrem from "./DientePrem"
import DienteCanino from "./DienteCanino"
import DienteIL from "./DienteIL"
import DienteIC from "./DienteIC"

import Diente48 from "./Diente48"
import Diente45 from "./Diente45"
import Diente43 from "./Diente43"
import Diente42 from "./Diente42"

//const data_init =[{ "pieza":"11,12", id_prod :2, partes:  "10000", color:"#efefef", interno: false}]

//------parametros inicializados
const RenderDientes = ({ data=[], onClickItem }) => {

  
  //let color= props.color || '#fff';
  //{ "pieza":12, id_prod :0, color:"white", partes:  "00000", interno: false},
  const onClickP = (pieza) => {
    console.log("onclickP:" + pieza );
    //this.props.onClickItem(pieza);
    onClickItem(pieza);
  }; 

  return (
  <>
    { data.map((item,index) =>(
      <div key={index}>
      {item.pieza=== 18 &&
        <DienteMo pieza={18}  color={item.color} width={40} height={52} style={{ top:'272', left:'68'}}
        onClick={() => onClickP(18)} className="di resalte1"/>
      }
      {item.pieza=== 17 &&
      <DienteMo pieza={17}  color={item.color} width={40} height={52} style={{ top:'227', left:'72'}}
        onClick={() => onClickP(17)}  className="di resalte1"/>
      }
      {item.pieza=== 16 &&
      <DienteMo pieza={16}  color={item.color} width={40} height={52} style={{ top:'182', left:'77'}}
        onClick={() => onClickP(16)} className="di resalte1"/>
      }
      {item.pieza=== 15 &&
      <DientePrem pieza={15}  color={item.color} width={32} height={46} style={{ top:'143', left:'88'}}
        onClick={() => onClickP(15)} className="di resalte1"/>
      }
      {item.pieza=== 14 &&
      <DientePrem pieza={14}  color={item.color} width={32} height={46} style={{ top:'108', left:'94'}}
        onClick={() => onClickP(14)} className="di resalte1"/>
      }
      {item.pieza=== 13 &&
      <DienteCanino pieza={13}  color={item.color} width={32} height={44} style={{ top:'79', left:'102'}}
        onClick={() => onClickP(13)} className="di resalte1"/>
      }
      {item.pieza=== 12 &&
      <DienteIL pieza={12} color={item.color} width={32} height={44} style={{ top:'66', left:'120'}}
        onClick={() => onClickP(12)} className="di resalte1"/>
      }
      {item.pieza=== 11 &&
      <DienteIC pieza={11} color={item.color} width={31} height={44} style={{ top:'63', left:'142'}}
        onClick={() => onClickP(11)} className="di resalte1"/>
      }

      {/*-- espejo ---*/}
      {item.pieza=== 21 &&
      <DienteIC pieza={21} color={item.color} width={31} height={44} style={{ top:'63', left:'166',transform: 'rotateY(180deg)'}} 
        onClick={() => onClickP(21)} className="di resalte1" />
      }
      {item.pieza=== 22 &&
      <DienteIL pieza={22} color={item.color} width={32} height={44} style={{ top:'68', left:'190',transform: 'rotateY(180deg)'}}
        onClick={() => onClickP(22)} className="di resalte1"/>
      }
      {item.pieza=== 23 &&
      <DienteCanino pieza={23} color={item.color} width={32} height={44} style={{ top:'79', left:'210',transform: 'rotateY(180deg)'}}
        onClick={() => onClickP(23)} className="di resalte1"/>
      }
      {item.pieza=== 24 &&
      <DientePrem pieza={24} color={item.color} width={32} height={46} style={{ top:'107', left:'217',transform: 'rotateY(180deg)'}}
        onClick={() => onClickP(24)} className="di resalte1"/>
      }
      {item.pieza=== 25 &&
      <DientePrem pieza={25} color={item.color} width={32} height={46} style={{ top:'144', left:'226',transform: 'rotateY(180deg)'}}
        onClick={() => onClickP(25)} className="di resalte1"/>
      }
      {item.pieza=== 26 &&
      <DienteMo pieza={26} color={item.color} width={40} height={52} style={{ top:'183', left:'227',transform: 'rotateY(180deg)'}}
        onClick={() => onClickP(26)} className="di resalte1"/>
      }
      {item.pieza=== 27 &&
      <DienteMo pieza={27} color={item.color} width={40} height={52} style={{ top:'229', left:'234',transform: 'rotateY(180deg)'}}
        onClick={() => onClickP(27)} className="di resalte1"/>
      }
      {item.pieza=== 28 &&
      <DienteMo pieza={28} color={item.color} width={40} height={52} style={{ top:'273', left:'238',transform: 'rotateY(180deg)'}}
        onClick={() => onClickP(28)} className="di resalte1"/>
      }
      {/*------------------- paladar de abajo -------------------------*/}
      {item.pieza=== 48 &&
      <Diente48 pieza={48} color={item.color} width={40} height={52} style={{ top:'68', left:'381'}}
        onClick={() => onClickP(48)} className="di resalte1"/>
      }
      {item.pieza=== 47 &&
      <Diente48 pieza={47} color={item.color} width={40} height={52} style={{ top:'115', left:'387'}}
        onClick={() => onClickP(47)} className="di resalte1"/>
      }
      {item.pieza=== 46 &&
      <Diente48 pieza={46} color={item.color} width={40} height={52} style={{ top:'161', left:'394'}}
        onClick={() => onClickP(46)} className="di resalte1"/>
      }

      {item.pieza=== 38 &&
      <Diente48 pieza={38} color={item.color} width={40} height={52} style={{ top:'68', left:'550',transform: 'rotateY(180deg)'}}
        onClick={() => onClickP(38)} className="di resalte1"/>
      }
      {item.pieza=== 37 &&
      <Diente48 pieza={37} color={item.color} width={40} height={52} style={{ top:'113', left:'546',transform: 'rotateY(180deg)'}}
        onClick={() => onClickP(37)} className="di resalte1"/>
      }
      {item.pieza=== 36 &&
      <Diente48 pieza={36} color={item.color} width={40} height={52} style={{ top:'160', left:'542',transform: 'rotateY(180deg)'}}
        onClick={() => onClickP(36)} className="di resalte1"/>
      }
      {/*--------------*/}
      {item.pieza=== 45 &&
      <Diente45 pieza={45} color={item.color} width={30} height={45} style={{ top:'207', left:'405'}}
        onClick={() => onClickP(45)} className="di resalte1"/>
      }
      {item.pieza=== 35 &&
      <Diente45 pieza={35} color={item.color} width={30} height={45} style={{ top:'205', left:'540',transform: 'rotateY(180deg)'}}
        onClick={() => onClickP(35)} className="di resalte1"/>
      }
      {/* -------------*/}
      {item.pieza=== 44 &&
      <Diente45 pieza={44} color={item.color} width={30} height={44} style={{ top:'243', left:'415'}}
        onClick={() => onClickP(44) }className="di resalte1"/>
      }
      {item.pieza=== 34 &&
      <Diente45 pieza={34} color={item.color} width={30} height={44} style={{ top:'240', left:'530',transform: 'rotateY(180deg)'}}
        onClick={() => onClickP(34)} className="di resalte1"/>
      }

      {item.pieza=== 43 &&
      <Diente43 pieza={43} color={item.color} width={32} height={49} style={{ top:'271', left:'427'}}
        onClick={() => onClickP(43)} className="di resalte1"/>
      }
      {item.pieza=== 33 &&
      <Diente43 pieza={33} color={item.color} width={32} height={49} style={{ top:'270', left:'518',transform: 'rotateY(180deg)'}}
        onClick={() => onClickP(33)} className="di resalte1"/>
      }
      {/*-------------- */}
      {item.pieza=== 42 &&
      <Diente42 pieza={42} color={item.color} width={25} height={42} style={{ top:'282', left:'449'}}
        onClick={() => onClickP(42)} className="di resalte1"/>
      }
      {item.pieza=== 41 &&
      <Diente42 pieza={41} color={item.color} width={25} height={42} style={{ top:'286', left:'467'}}
        onClick={() => onClickP(41)} className="di resalte1"/>
      }
      {item.pieza=== 31 &&
      <Diente42 pieza={31} color={item.color} width={25} height={42} style={{ top:'286', left:'486'}}
        onClick={() => onClickP(31)} className="di resalte1"/>
      }
      {item.pieza=== 32 &&
      <Diente42 pieza={32} color={item.color} width={25} height={42} style={{ top:'282', left:'505'}}
        onClick={() => onClickP(32)} className="di resalte1"/>
      }


        </div>
      ))}
  </>
)};
export default RenderDientes;